module.exports = __webpack_public_path__ + "media/images/flags/64/Kenya-948be3d894fd6721cd5818e9c8c2a4a3.png";